export const environment = {
  production: false,
  apiBaseUrl: 'https://develop.sf24.api.smartfit100.com/v1',
  sfTopUrl: 'https://smartfit100.com',
  myPageUrl: 'https://develop.sf24.mypage.smartfit100.com',
  shopId: 'tshop00041480',
  timeout: 5000,
  ccUrl: 'https://www.saisoncard.co.jp/lineup/digital/v2000.html?cd=14V1&sd=270&mi=1000020',
  btPostUrl: 'https://www.acctrans-reg.jp/rtex/ar/nj3XA53q/',
  mulPayTokenUrl: 'https://stg.static.mul-pay.jp/ext/js/token.js',
};
